<template>
    <v-dialog v-model="dialog" max-width="960px" persistent transition="dialog-bottom-transition" scrollable hide-overlay>
		<v-card tile>
			<v-toolbar card dark color="primary" :extension-height="10" extended>
				<v-toolbar-title>
                    <div v-if="hrDocument" style="display: inline-block;">
                        <v-chip v-if="versionNo" color="indigo" style="margin-top: -20px;">V.{{ versionNo }}</v-chip>
                    </div>
                    <div v-if="hrDocument" style="display: inline-block" class="ml-2 mt-2 text-xs-left">
                        <div style="display: block;">
                            {{ title }}
                            <div class="caption">{{ dateFromToMessage }}</div>
                        </div>
                        
                    </div>
                    
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="closeDialog()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-toolbar>
            
			<v-card-text>
                <loading-indicator 
				v-if="isLoading" 
				loading-text="Loading HR Document..." />

                <hr-document-previous-version 
                    v-if="hrDocument"
                    :hr-document="hrDocument" 
                    :logged-in-tenant="loggedInTenant" 
                    :is-admin="loggedInEmployee.isAdmin" />
			</v-card-text>

			<div style="flex: 1 1 auto;"></div>
		</v-card>
	</v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex';
	import HrDocumentPreviousVersion from '@/components/hrDocuments/HrDocumentPreviousVersion';
    import LoadingIndicator from '@/components/common/LoadingIndicator';

	export default {
		components: {
			HrDocumentPreviousVersion,
            LoadingIndicator
		},
		props: {
			id: {
				// HR Document Id
				required: true
			},
            versionNo: {
                type: Number,
                required: true
            },
            dialog: {
                type: Boolean
            }
		},
        data() {
            return {
				hrDocument: null,
				isLoading: false
            }
        },
        watch: {
            id: {
                immediate: true,
                handler() {
                    if (this.id) {
                        this.hrDocument = null;
                        this.loadDocument();
                    }
                }
            }
        },
        computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant'
			}),
            title() {
                return !this.hrDocument ? '' : `${this.hrDocument.name}`;
            },
            dateFromToMessage() {
                if (!this.hrDocument) return "";

                return `In use from ${this.$options.filters.formatDate(this.hrDocument.dateFromUTC)} - ${this.$options.filters.formatDate(this.hrDocument.dateToUTC)}`;
            }
		},
        methods: {
            closeDialog() {
                this.$emit('closeDialog');
            },
            async loadDocument() {
                this.isLoading = true;
				const result = await this.$store.dispatch('hrDocuments/getPreviousVersion', { id: this.id, versionNo: this.versionNo });
				if (result.isSuccess) {
					this.hrDocument = result.data;
				}
				this.isLoading = false;
			},
        }
	};
</script>

<style></style>